import { S2SafeParsable } from 'libs/end-to-end/src/interfaces';
import { createZodParseError } from 'libs/end-to-end/src/utils/utility/create-zod-parse-error';
import { errResult } from 'libs/end-to-end/src/result';
import { okResult } from 'libs/end-to-end/src/result';
import { Result } from 'libs/end-to-end/src/result';
import { ZodParseError } from 'libs/end-to-end/src/types/errors/zod-parse-error';

export const zodParseSafe = <TRecord>(
  input: unknown,
  schema: S2SafeParsable<unknown, TRecord>,
): Result<TRecord, ZodParseError> => {
  const parseResult = schema.safeParse(input);

  if (!parseResult.success) {
    return errResult(createZodParseError(parseResult));
  }

  return okResult(parseResult.data);
};
